import api from './api';

/** Addresses the acting organisation notifies about Urlaub/Gleitzeit/Überstunden. */
export const getNotificationRecipients = async () => {
    const res = await api.get('/NotificationRecipient');
    return res.data || [];
};

export const addNotificationRecipient = async (recipient) => {
    const res = await api.post('/NotificationRecipient', recipient);
    return res.data;
};

/** Patch a recipient. Only the keys passed are written, so send `subscriptions: []` to unsubscribe
 *  the address and omit the key to leave its subscriptions alone. */
export const updateNotificationRecipient = async (id, patch) => {
    const res = await api.patch(`/NotificationRecipient/${id}`, patch);
    return res.data;
};

export const deleteNotificationRecipient = async (id) => {
    const res = await api.delete(`/NotificationRecipient/${id}`);
    return res.data;
};
